export default "__VITE_ASSET__yWjQ7Hq___"